import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Text, Button } from '@mantine/core';

export default function ConfirmationModal({
  title,
  message,
  confirmLabel = 'Confirm',
  onConfirm,
  opened,
  close,
  closeOnClickOutside = true,
}) {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    close();
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={title}
      data-testid={title}
      withCloseButton
      closeOnClickOutside={closeOnClickOutside}
    >
      {message && <Text mb="md">{message}</Text>}
      <Button
        fullWidth
        onClick={handleConfirm}
        data-testid="ConfirmButton"
      >
        {confirmLabel}
      </Button>
    </Modal>
  );
}

ConfirmationModal.propTypes = {
  title: PropTypes.node.isRequired,
  message: PropTypes.node,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  opened: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  closeOnClickOutside: PropTypes.bool,
};
